// extracted by mini-css-extract-plugin
module.exports = {"SectionSolarStation":"SectionSolarStation_SectionSolarStation__DFPf7"};